import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../helpers/custom-prop-types';
const ArrowNextIcon = ({ className }) => (_jsx("svg", Object.assign({ className: `svg-arrow-next-icon ${className}`, height: '11.175', viewBox: '0 0 6.585 11.175', width: '6.585', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsx("path", { d: 'M9.463,6.293a1.018,1.018,0,0,0,1.42,0,1,1,0,0,0,0-1.41L6.292.292a1,1,0,0,0-1.41,0L.293,4.883A1,1,0,0,0,1.7,6.293l3.88-3.88,3.88,3.88Z', fill: '#fff', transform: 'translate(6.585 0) rotate(90)' }) })));
ArrowNextIcon.propTypes = {
    className: propStr(),
};
ArrowNextIcon.defaultProps = {
    className: '',
};
export default ArrowNextIcon;
